import certificationmain       from '@/pages/certification/certification-main/CertificationMain.vue'
import cics       from '@/pages/certification/cics/Cics.vue'
import cicp       from '@/pages/certification/cicp/Cicp.vue'
import examregistration       from '@/pages/certification/exam-registration/ExamRegistration.vue'
import examregistration2       from '@/pages/certification/exam-registration2/ExamRegistration2.vue'




export default [
    {
        path: '/certificationmain',
        name: 'certificationmain',
        component: certificationmain,
    },
    {
        path: '/cics',
        name: 'cics',
        component: cics,
    },
    {
        path: '/cicp',
        name: 'cicp',
        component: cicp,
    },
    {
        path: '/examregistration',
        name: 'examregistration',
        component: examregistration,
    },
    {
        path: '/examregistration2',
        name: 'examregistration2',
        component: examregistration2,
    }
]
